













































import { Component, Prop, Vue } from "vue-property-decorator";
import { VisitModel } from "@/components/patient/record2/types";

@Component
export default class Information extends Vue {
  @Prop({ default: "prefix" }) private prefix_id!: string;
  @Prop() private readonly model!: VisitModel;
  @Prop() private fixed_message!: string;

  private get LastCharMinus() {
    if (this.model.is_fixed_message_enabled) {
      return 55;
    } else {
      return 24;
    }
  }
}
